// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_formStyle__0PsZS {
  margin-bottom: 0;
}

.styles_haveAccount__zfF9p {
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: auto;
  display: flex;
  margin-top: 14px;
  margin-bottom: 40px;
}

.styles_inputContainer__wkVNE {
  margin-bottom: 30px;
  width: 100%;
}

.styles_inputContainerMobile__ufRdi {
  width: calc(100% - 100px);
}

.styles_inputContainerCode__6QQ19 {
  width: 80px;
}

.styles_wrapper__MToTq {
  width: 100%;
}

.styles_submitItem__AD5pe {
  font-style: normal;
  font-weight: 500;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #d8000d;
  cursor: pointer;
}

.styles_formButton__-i2ke {
  width: 100% !important;
}

.styles_formButton__-i2ke > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SignUpMobile/styles.module.scss"],"names":[],"mappings":"AAOA;EACE,gBAAA;AANF;;AASA;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AASA;EACE,mBAAA;EACA,WAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,WAAA;AANF;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAPF","sourcesContent":["// @use '@/form_core.scss';\n\n.container {\n  // padding-left: 1.5rem;\n  // padding-right: 1.5rem;\n}\n\n.formStyle {\n  margin-bottom: 0;\n}\n\n.haveAccount {\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  width: auto;\n  display: flex;\n  margin-top: 14px;\n  margin-bottom: 40px;\n}\n\n.inputContainer {\n  margin-bottom: 30px;\n  width: 100%;\n}\n\n.inputContainerMobile {\n  width: calc(100% - 100px);\n}\n\n.inputContainerCode {\n  width: 80px;\n  // margin: 0 10px;\n}\n\n.wrapper {\n  width: 100%;\n}\n\n.submitItem {\n  font-style: normal;\n  font-weight: 500;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: #d8000d;\n  cursor: pointer;\n}\n\n.formButton {\n  width: 100% !important;\n}\n\n.formButton>button {\n  width: 100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formStyle": `styles_formStyle__0PsZS`,
	"haveAccount": `styles_haveAccount__zfF9p`,
	"inputContainer": `styles_inputContainer__wkVNE`,
	"inputContainerMobile": `styles_inputContainerMobile__ufRdi`,
	"inputContainerCode": `styles_inputContainerCode__6QQ19`,
	"wrapper": `styles_wrapper__MToTq`,
	"submitItem": `styles_submitItem__AD5pe`,
	"formButton": `styles_formButton__-i2ke`
};
export default ___CSS_LOADER_EXPORT___;
